
import React, { useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image'
import useSWR, { SWRConfig } from 'swr';
import { useGetWindowWidth } from 'lib/hooks/useGetwidth';
import Loader from 'components/Loader'

//- GraphQL Imports
import { request } from 'graphql-request';

//- Other Imports
import randomWords from 'random-words';
import randomNumber from 'random-number';
import testing from '../../ref/testing';
import { placeholder } from 'utility/placeholder'
import Picture from 'components/SrcSetImg/Picture';

//- Style Imports
import styles from './artists.module.css';

//- Copmonent Imports

import {
  PageCounter,
  ZeroState,
  SearchInput,
  SimpleOptionDropdown,
  MobileFilterMenu,
} from 'components';
import MultipleFilterDropdown from 'components/MultipleFilterDropdown/MultipleFilterDropdown';
import { ArtistSortOptions } from '../../ref/filters';
import axios from 'axios';
import Link from 'next/link';
import { TagsContext } from 'lib/providers/tags';
import { SortDir } from 'components/SortDir/SortDir';

const noProfilePicture = '/assets/black_avatar.png';

export const Artists = ({ artistsSlugs }) => {
  console.log(artistsSlugs)
  let { mobile } = useGetWindowWidth();
  let { mediums, generateArray, getMediumIds } = useContext(TagsContext);
  let [searchedArtists, setSearchedArtists] = useState<any[]>([]);
  let [error, setError] = useState(null)
  let router = useRouter()

  // Queries
  let [mediumFilters, setMediumFilters] = useState<any[] | null>([]);
  let [searchQuery, setSearchQuery] = useState<string | null>(null);
  let [mintedRange, setMintedRange] = useState<Date[] | null[]>([null, null]);
  let [sortOption, setSortOption] = useState<string | null>("created_at:DESC");
  let [isSortedDesc, setIsSortedDesc] = useState<boolean>(true)

  // Pagination
  let [totalPages, setTotalPages] = useState<number>(1)
  let [currentPage, setCurrentPage] = useState<number>(router?.query?.page ? Number(router.query.page) : 1)
  let [countPerPage, setCountPerPage] = useState<number>(20)
  let [artistsTotalCount, setArtistsTotalCount] = useState<number>(0)
  let [loading, setLoading] = useState(false)

  const header = () => (
    <div className={styles.Header}>
      <h1 className={styles.PageTitle}>Artists</h1>
    </div>
  );

  const handleLastMinted = (selected) => {
    if (selected === 'All') {
      setMintedRange([null, null])
    } else if (selected === 'Today') {
      let now = new Date()
      let yesterday = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
      setMintedRange([yesterday, now])
    } else if (selected === 'Yesterday') {
      let yesterday = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
      let yesterdaysyesterday = new Date(new Date(yesterday).getTime() - (24 * 60 * 60 * 1000));
      setMintedRange([yesterdaysyesterday, yesterday])
    } else if (selected === 'Last week') {
      let yesterday = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
      let lastweek = new Date(new Date(yesterday).getTime() - (7 * 24 * 60 * 60 * 1000));
      setMintedRange([lastweek, yesterday])
    } else if (selected === 'Last month') {
      let yesterday = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
      let lastmonth = new Date(new Date(yesterday).getTime() - (30 * 7 * 24 * 60 * 60 * 1000));
      setMintedRange([lastmonth, yesterday])
    }
  }

  const handleSort = (selected) => {
    if (selected === 'Date Minted') {
      setSortOption(`minted_artworks.created_at:${isSortedDesc ? "DESC" : "ASC"}`)
    } else if (selected === 'Date Joined') {
      setSortOption(`created_at:${isSortedDesc ? "DESC" : "ASC"}`)
    } else if (selected === 'FLIPIT') {
      // functionality for the reverse sort direction button
      setIsSortedDesc(!isSortedDesc)
      if (isSortedDesc) {
        setSortOption(sortOption.replace("DESC", "ASC"))
      } else {
        setSortOption(sortOption.replace("ASC", "DESC"))
      }
    }
  }

  useEffect(() => {
    const getArtists = async () => {
      setError(null)
      setLoading(true)
      let params;
      if (searchQuery || mintedRange[0] || mintedRange[1] || sortOption || mediumFilters?.length > 0) {
        params = new URLSearchParams(); // using URLSearchParams because of the repeating `mediumFilters` query...
        //...axios takes an object otherwise and the multi entries per key would overwrite each other
        // ie. "?cat_in=4&cat_in=5&cat_in=5" vs "?cat_in=5"
        searchQuery && params.append("slug_contains", searchQuery.replace(/\s+/g, '-').toLowerCase())
        mintedRange[0] && params.append("minted_artworks.created_at_gte", mintedRange[0].toISOString())
        mintedRange[1] && params.append("minted_artworks.created_at_lte", mintedRange[1].toISOString())
        sortOption ? params.append("_sort", sortOption) : params.append("_sort", isSortedDesc ? "minted_artworks.created_at:DESC" : "minted_artworks.created_at:ASC")
        countPerPage && params.append("_limit", countPerPage)
        countPerPage * (currentPage - 1) > 0 && params.append("_start", (countPerPage * (currentPage - 1)))
        mediumFilters?.length > 0 && getMediumIds(mediumFilters).map(mediumId => (
          params.append("minted_artworks.medium_in", mediumId)
        ))
        params.append("minted_artworks_null", "false")
        params.append("minted_artworks.created_at_null", "false")
      }
      try {
        await axios.get(`${process.env.NEXT_PUBLIC_REACT_APP_STRAPI_API_URL}/artists`, { params: params }).then(resp => {
          setLoading(false)
          setSearchedArtists(resp.data.users)
          setArtistsTotalCount(resp.data.count)
          setTotalPages(Math.ceil(resp.data.count / countPerPage))
        });
      } catch (error) {
        setLoading(false)
        setError("Error while getting artists")
      }
    }

    getArtists()
  }, [searchQuery, mintedRange, sortOption, mediumFilters, isSortedDesc, currentPage])

  useEffect(() => {
    if (router.query.page) {
      setCurrentPage(Number(router.query.page))
    }
  }, [router.query])

  return (
    <main className={styles.Container}>
      {header()}
      {mobile ? (
        <MobileFilterMenu
          sortOptionLabel={'Sort'}
          sortOptions={ArtistSortOptions}
          filterMenuProps={{
            children: (
              <>
                <SearchInput
                  className={styles.Search}
                  onSubmit={setSearchQuery}
                  placeholder="Search by artist name"
                />
                <SimpleOptionDropdown
                  options={['All', 'Today', 'Yesterday', 'Last week', 'Last month']}
                  onSelect={(selected: string) => handleLastMinted(selected)}
                  label={'Last minted'}
                />
                <MultipleFilterDropdown
                  customHeaderText={'Any'}
                  options={generateArray(mediums, "type")}
                  label={'Mediums'}
                  onSelect={(selected: string) => setMediumFilters([...mediumFilters, selected])}
                  selectedArray={mediumFilters}
                  setSelectedArray={setMediumFilters}
                  selectionLimit={5}
                />
                <SortDir onClick={() => handleSort("FLIPIT")} isSortedDesc={isSortedDesc} />
                <SimpleOptionDropdown
                  options={['Date Joined', 'Date Minted']}
                  rightAligned
                  onSelect={(option: string) => handleSort(option)}
                  label={'Sort by'}
                />
              </>
            ),
          }}
        />
      ) : (
        <section className={styles.Filters}>
          <SearchInput
            className={styles.Search}
            onSubmit={setSearchQuery}
            placeholder="Search by artist name"
          />
          <SimpleOptionDropdown
            options={['All', 'Today', 'Yesterday', 'Last week', 'Last month']}
            onSelect={(selected: string) => handleLastMinted(selected)}
            label={'Last minted'}
          />
          <MultipleFilterDropdown
            customHeaderText={'Any'}
            options={generateArray(mediums, "type")}
            label={'Mediums'}
            onSelect={(selected: string) => setMediumFilters([...mediumFilters, selected])}
            selectedArray={mediumFilters}
            setSelectedArray={setMediumFilters}
            selectionLimit={5}
          />
          <SortDir onClick={() => handleSort("FLIPIT")} isSortedDesc={isSortedDesc} />
          <SimpleOptionDropdown
            options={['Date Joined', 'Date Minted']}
            rightAligned
            onSelect={(option: string) => handleSort(option)}
            label={'Sort by'}
          />
        </section>
      )}
      <section className={styles.Artists}>
        {!loading ?
          <ul>
            {searchedArtists?.length > 0 ? (
              searchedArtists.map((artist, i) => (
                <li className={styles.Artist} key={i}>
                  <Link href={`/artists/${artist.slug}`}>
                    <a>
                      <div className={styles.DP}>
                        <Picture
                          className={styles.teamPic}
                          imageObj={artist.profile_picture} size={"small"}
                          fallback={"/assets/black_avatar.png"}
                          alt={artist.profile_picture?.alternativeText} />
                      </div>
                      <h4 style={{ wordWrap: 'break-word' }}>{artist?.username}</h4>
                    </a>
                  </Link>
                </li>
              ))
            ) : (
              <ZeroState searchedParam="your given params" paramType="filters" />
            )}
          </ul>
          : <Loader />
        }
        {totalPages > 0 ? (
          <PageCounter slug={router.route} pages={totalPages} />
        ) : ""}
      </section>
    </main >
  )
}

export async function getStaticProps() {
  const artistsRes = await axios.get(
    `${process.env.NEXT_PUBLIC_REACT_APP_STRAPI_API_URL}/artists`
  );

  const artistsSlugs = artistsRes.data.users.map(artist => artist.slug)

  return {
    props: {
      artistsSlugs: artistsSlugs
    }
  }
}

export default Artists;